<template>
        <div>
            <slide-y-up-transition>
            <div  v-if="open" class="modal fade" :class="{ show:  open }" tabindex="-1" role="dialog"  @click="hide" ref="modal">
                <div class="modal-dialog" :class="dialogClass" role="document">
                    <div class="modal-content">
                        <div class="mt-3 mr-4">
                            <button type="button" class="close" @click="hide" v-if="!$slots.title">
                                <span aria-hidden="true" ref="close1">&times;</span>
                            </button>
                        </div>
                        <div class="modal-header"  v-if="!!$slots.title">
                            <h5 class="modal-title">
                                <slot name="title"></slot>
                            </h5>
                            <button type="button" class="close" @click="hide">
                                <span aria-hidden="true" ref="close2">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body" :class="bodyClass">
                            <slot></slot>
                        </div>
                        <div class="modal-footer"  v-if="$slots.footer">
                            <slot name="footer"></slot>
                        </div>
                    </div>
                </div>
            </div>
            </slide-y-up-transition>
                <div class="backdrop" :class="{ show:  open }"></div>
        </div>
</template>

<script>
import {SlideYUpTransition} from 'vue2-transitions'

export default {
        props: {
          bodyClass: [String, Array, Object],
          dialogClass: [String, Array, Object]
        },
        components: {SlideYUpTransition},
        data: function () {
            return {
                open: false,
            }
        },
        methods: {
            show: function () {
                this.open = true;
            },
            hide: function (e) {
                if(!e){
                    this.open = false;
                    return
                }
                if(this.$refs.modal === e.target || this.$refs.close1 === e.target || this.$refs.close2 === e.target){
                    this.open = false;
                }
            },
            toggle: function () {
                this.open = !this.open;

            },
        }
    }
</script>

<style lang="scss" scoped>
    .modal {
        z-index: 10050;
        &.show {
            display: block;
        }
    }


    .backdrop {
        z-index: 10040;
        background-color: #000;
        opacity: 0;
        position: fixed;
        transition: opacity 0.3s;

        &.show {
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            opacity: 0.5;
        }
    }
</style>
